import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { pillars, volumes, volumeIncludes } from '../data/volumes';
export function Volumes() {
  return <section aria-label="What is inside the ebook" className="bg-transparent" data-id="element-220" data-mp="184f1q1waxg7h">
      <div className="mx-auto max-w-6xl px-5 py-12" style={{
      paddingTop: '19px',
      paddingBottom: "21px"
    }} data-id="element-221" data-mp="1c5gr7r0f2dw9">
        <div className="text-center" data-id="element-222" data-mp="1zvb1q1x9jqdc">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-grape" data-id="element-223" data-mp="1zwcq183ai9d0">
            🧩 THE AUTONOMOUS CHILD VISUAL SYSTEM™
          </p>
          <h2 className="mt-3 font-display text-3xl font-black text-plum sm:text-4xl" data-id="element-224" data-mp="1qud88dkgb190">
            What Will You Find Inside?
          </h2>
          <p className="mt-2 text-base text-plum/60" data-id="element-225" data-mp="1vserayhvn0kh">
            6 routine volumes · 50 print-ready pages — morning, afternoon and night in one place.
          </p>
          <div className="mt-6 flex flex-wrap justify-center gap-2" data-id="element-226" data-mp="keaulkjwmybq">
            {pillars.map(p => <span key={p} className="rounded-full border border-grape/25 bg-lilac-soft px-3 py-1 text-xs font-bold uppercase tracking-wide text-plum-soft" data-id="element-227" data-mp="kby9iyiuo7ug">
                {p}
              </span>)}
          </div>
          <p className="mt-8 font-display text-lg font-black uppercase tracking-[0.18em] text-plum-soft" data-id="element-228" data-mp="20owi1r8c6e9">
            📚 The 6 Routine Volumes
          </p>
        </div>

        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-229" data-mp="3t9cjem54c1nx">
          {volumes.map((t, i) => <motion.article key={t.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: i % 3 * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="group rounded-2xl border border-grape/15 bg-white p-5 transition-colors duration-200 ease-out hover:border-grape/45" style={{
          paddingTop: "10px",
          paddingBottom: "8px"
        }} data-id="element-230" data-mp="azk2bcqd3eh1" data-mpi={i}>
              <div className="flex items-center gap-3" data-id="element-231" data-mp="psdqdmjp92xb">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-lilac-soft font-display text-lg font-black text-grape" data-id="element-232" data-mp="wuiqblrijudx">
                  {String(t.n).padStart(2, '0')}
                </span>
                <h3 className="text-sm font-bold leading-tight text-plum" data-id="element-233" data-mp="16qcb1sfdyu6s">
                  <span aria-hidden="true" data-id="element-234" data-mp="1bjowxusokmvu">{t.emoji} </span>
                  {t.title}
                </h3>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-plum/65" data-id="element-235" data-mp="1fjpe3n75zc6l">{t.desc}</p>
            </motion.article>)}
        </div>

        <div className="mt-10 rounded-2xl border border-grape/25 bg-white p-6" data-id="element-236" data-mp="1kl4ydd1ipenx">
          <p className="text-center font-display text-lg font-black text-grape" data-id="element-237" data-mp="1pj6bzig6cls0">
            ✅ Key features — simple to use, flexible to adapt
          </p>
          <ul className="mt-5 grid gap-3 sm:grid-cols-2 lg:grid-cols-4" data-id="element-238" data-mp="3rajj8e5m75r8">
            {volumeIncludes.map(item => <li key={item} className="flex items-start gap-2 text-sm text-plum/75" data-id="element-239" data-mp="2ox8e4075rs">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-grape" strokeWidth={3} data-id="element-240" data-mp="2de9uug6g6exp" />
                {item}
              </li>)}
          </ul>
        </div>

        <div className="mx-auto mt-10 max-w-2xl rounded-2xl border border-blush/30 bg-blush-soft p-6 text-center" data-id="element-241" data-mp="28kx7sahf2g72">
          <p className="font-display text-lg font-black text-blush-deep" data-id="element-242" data-mp="1zmbryn3bxf9z">
            No other subscription
          </p>
          <p className="mt-2 text-sm text-plum/70" data-id="element-243" data-mp="2wd44xbuyur7j">
            Use it without adding another monthly bill to your family.
          </p>
          <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-sm font-semibold text-plum/80" data-id="element-244" data-mp="2sbimlaznxkpy">
            {['One-time payment only', 'No monthly subscription', 'No ads', 'No files to install', 'Mobile-friendly'].map(item => <li key={item} className="inline-flex items-center gap-1.5" data-id="element-245" data-mp="1bwhga8uqxwrb">
                <CheckIcon className="h-4 w-4 shrink-0 text-blush" strokeWidth={3} data-id="element-246" data-mp="1bueeyso58h7a" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}